import styles from './NoticeAnnouncementCard.module.css';
import { PiClockLight } from 'react-icons/pi';
import { useMemo, useEffect, useState } from 'react';

const themeVars = [
  "--Primary_Color",
  "--Success_Color",
  "--Utility_Color1",
  "--Warning_Color",
  "--Info_Color",
];


const NoticeAnnouncementCard = ({ day, date, image, message, sender, timeAgo }) => {
  const [bgColor, setBgColor] = useState('');

  useEffect(() => {
    const themeElement = document.querySelector(".theme");
    const randomVar = themeVars[Math.floor(Math.random() * themeVars.length)];
    const color = themeElement
      ? getComputedStyle(themeElement).getPropertyValue(randomVar).trim()
      : "#ccc";
    setBgColor(`rgba(${hexToRgb(color)}, 0.15)`);
  }, []);
  

  return (
    <div className={styles.card} style={{ backgroundColor: bgColor }}>
      <div className={styles.date}>
        <p>{day}</p>
        <p>{date}</p>
      </div>

      <img src={image} alt="notice" className={styles.image} />

      <div className={styles.content}>
  <p className={styles.message}>{message}</p>
  <div className={styles.footer}>
    <span className={styles.sender}>- {sender}</span>
    <span className={styles.time}>
      <PiClockLight className={styles.clockIcon} />
      {timeAgo}
    </span>
  </div>
</div>

    </div>
  );
};

function hexToRgb(hex) {
  hex = hex.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `${r}, ${g}, ${b}`;
}

export default NoticeAnnouncementCard;